import styled from '@eduzz/houston-styles/styled';

export const Content = styled.div`
  .image-bump {
    height: 64px;
    width: 100%;
  }
`;
